export default __webpack_public_path__ + "static/media/dentaverse2.2ed4fb94.PNG";